import { t } from "../../../lib/sprache";

/** Antwort von payout_run_complete (0085): vermerkte Posten und Posten, die offen bleiben (mit Grund). */
export interface CompleteResult {
  run_id: string;
  status: string;
  paid: number;
  failed?: { item_id: string; invoice_id: string; number: string | null; error: string }[];
}

/**
 * Meldung nach „Als ausgezahlt vermerken“ (AUTOMATIK-12): Ein einzelner Posten bricht den Lauf nicht mehr ab. Bleiben Posten
 * offen, nennt die Meldung sie mit Grund, und der Lauf bleibt stehen, bis sie erledigt oder herausgenommen sind.
 */
export function completeMessage(r: CompleteResult): { message: string; alert: boolean } {
  const failed = r.failed ?? [];
  if (!failed.length) return { message: t("Als ausgezahlt vermerkt; die Creator werden gefragt.", "Marked as paid out; the creators are asked."), alert: false };
  const list = failed.map((f) => `${f.number ?? t("ohne Nummer", "no number")}: ${f.error}`).join("; ");
  return {
    message: t(`${r.paid} vermerkt, ${failed.length} offen geblieben (${list}). Kläre diese Posten oder nimm sie heraus, dann erneut vermerken.`,
      `${r.paid} marked, ${failed.length} still open (${list}). Resolve these items or take them out, then mark again.`),
    alert: true,
  };
}
